var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3591_14717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.713 8.077C26.4317 7.73944 26.0796 7.46795 25.6815 7.28182C25.2835 7.09568 24.8494 6.99946 24.41 7H8.242L8.2 6.649C8.11405 5.91942 7.76338 5.24673 7.21449 4.75848C6.6656 4.27022 5.95663 4.00034 5.222 4H5C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5C4 5.26522 4.10536 5.51957 4.29289 5.70711C4.48043 5.89464 4.73478 6 5 6H5.222C5.46693 6.00003 5.70334 6.08996 5.88637 6.25272C6.06941 6.41547 6.18634 6.63975 6.215 6.883L7.591 18.583C7.73385 19.7998 8.31848 20.9218 9.23391 21.736C10.1493 22.5502 11.3319 23 12.557 23H23C23.2652 23 23.5196 22.8946 23.7071 22.7071C23.8946 22.5196 24 22.2652 24 22C24 21.7348 23.8946 21.4804 23.7071 21.2929C23.5196 21.1054 23.2652 21 23 21H12.557C11.9381 20.9983 11.3348 20.8051 10.8299 20.4471C10.3251 20.089 9.94331 19.5835 9.737 19H21.657C22.8293 19.0001 23.9643 18.5882 24.8638 17.8364C25.7633 17.0846 26.37 16.0407 26.578 14.887L27.363 10.533C27.4414 10.101 27.4237 9.65707 27.3114 9.23264C27.1991 8.80821 26.9948 8.41368 26.713 8.077ZM25.4 10.178L24.614 14.532C24.4891 15.225 24.1245 15.852 23.5839 16.3032C23.0433 16.7544 22.3612 17.0011 21.657 17H9.419L8.478 9H24.41C24.5569 8.99912 24.7022 9.03062 24.8355 9.09226C24.9689 9.15389 25.087 9.24415 25.1815 9.35661C25.276 9.46907 25.3446 9.60097 25.3824 9.74294C25.4201 9.8849 25.4262 10.0334 25.4 10.178Z",
    fill: "url(#paint0_linear_3591_14717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 28.001C12.1046 28.001 13 27.1055 13 26.001C13 24.8964 12.1046 24.001 11 24.001C9.89543 24.001 9 24.8964 9 26.001C9 27.1055 9.89543 28.001 11 28.001Z",
    fill: "url(#paint1_linear_3591_14717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 28.001C22.1046 28.001 23 27.1055 23 26.001C23 24.8964 22.1046 24.001 21 24.001C19.8954 24.001 19 24.8964 19 26.001C19 27.1055 19.8954 28.001 21 28.001Z",
    fill: "url(#paint2_linear_3591_14717)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3591_14717",
    x1: 4,
    y1: 25.0357,
    x2: 29.4922,
    y2: 18.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3591_14717",
    x1: 9,
    y1: 28.4295,
    x2: 13.4611,
    y2: 27.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3591_14717",
    x1: 19,
    y1: 28.4295,
    x2: 23.4611,
    y2: 27.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3591_14717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBasket);
export default __webpack_public_path__ + "static/media/avatar-basket.3879fdbce294c764e1a03a87fd8a264b.svg";
export { ForwardRef as ReactComponent };